import script from "./SignModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SignModal.vue?vue&type=script&setup=true&lang=js"

import "./SignModal.vue?vue&type=style&index=0&id=2538df84&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2538df84"]])

export default __exports__